import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // In a production app, we would log this to Firestore or an observability service
    console.error('ErrorBoundary caught an unhandled crash:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handlePurgeAndReload = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
    } catch (e) {
      console.error('Failed to clear application storage:', e);
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col bg-charcoal-dark text-slate-200 justify-center items-center p-6 font-sans">
          <div className="chrome-panel border border-red-500/30 bg-charcoal-card max-w-lg w-full rounded-lg p-6 shadow-2xl relative z-10 text-center space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 text-xs font-bold uppercase tracking-wider">
              ⚠️ System Exception Caught
            </div>
            
            <h1 className="text-2xl md:text-3xl font-extrabold text-white uppercase tracking-tight font-display">
              Application Crashed
            </h1>
            
            <p className="text-sm text-slate-400 leading-relaxed">
              Something went wrong while rendering this page. If this issue persists after reloading, try purging the cached form drafts.
            </p>

            <div className="flex flex-wrap gap-3 justify-center">
              <button
                type="button"
                onClick={this.handleReload}
                className="cyber-btn-orange py-2 px-4 text-xs uppercase font-bold"
              >
                Reload App
              </button>
              <button
                type="button"
                onClick={this.handlePurgeAndReload}
                className="bg-red-500/10 hover:bg-red-500/20 text-red-400 font-bold py-2 px-4 rounded-lg transition-colors text-xs uppercase border border-red-500/30"
              >
                Purge Cache &amp; Reload
              </button>
            </div>

            {this.state.error && (
              <details className="text-left bg-charcoal-dark border border-white/5 rounded p-3 text-xs font-mono max-h-48 overflow-y-auto">
                <summary className="text-slate-400 cursor-pointer select-none font-bold uppercase tracking-wider text-2xs mb-2">
                  Diagnostic Case File
                </summary>
                <p className="text-red-400 font-bold mb-1">{this.state.error.toString()}</p>
                {this.state.errorInfo && (
                  <pre className="text-slate-500 whitespace-pre-wrap text-[10px] leading-tight">
                    {this.state.errorInfo.componentStack}
                  </pre>
                )}
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
